import React, { useState, useEffect } from 'react';
import styles from './cvReviews.module.scss';
import { Card, Col, Container, Row, Image } from 'react-bootstrap';
import { getAllCVReviewGroups } from '../../../services/util/cvReview';
import CSSLoader from '../../shared/cssLoader';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomAvatarList } from '../../shared/customAvatarList';
import { CustomPreIcon } from '../../shared/customPreIcon';


const CVReview = (props) => {
    let concatValue;
    const [isLoading, setLoading] = useState(false);
    let [cvReviewValues, setCVReviewValues] = useState([]);

    const breadcrumb = [
        {
            pathaddress: '/app/company/reviews',
            pathname: 'CV Reviews',
            isActive: false,
            key: 1 + 'cv-review'
        }
    ];

    const breacrumbText = 'Here you can see candidate profiles waiting for your feedback. CVs get automatically assigned to you if you were assigned as a CV reviewer in a pipeline.'

    const getAllCVReviews = async () => {
        setLoading(true)
        const values = await getAllCVReviewGroups();
        if (values.success === true) {
            setCVReviewValues(values.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    function viewCVDetails(step_id) {
        props.history({
            pathname: `/company/reviews/group`,
            search: `?step_id=${step_id}`
        });
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function truncateValue(value, maxLength) {
        return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
    }

    // Company Settings Integration API call
    let [isURLLoading, setURLLoading] = useState(false);

    useEffect(() => {
        getAllCVReviews();
    }, []);

    useEffect(() => {
        let pageHit = '/app/company/cv-reviews';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])


    return (
        <div>
            <Helmet>
                <title>CV Reviews | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (cvReviewValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>

                                            <Card className={styles.cardOuterBox}>
                                                <Card.Body >
                                                    <div className={styles.cardTitleBox}>
                                                        <CustomPreIcon
                                                            type="successIcon"
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                                    <path d="M1 10.941L10.6422 15.7621C10.7734 15.8277 10.839 15.8605 10.9078 15.8734C10.9687 15.8848 11.0313 15.8848 11.0922 15.8734C11.161 15.8605 11.2266 15.8277 11.3578 15.7621L21 10.941M1 15.941L10.6422 20.7621C10.7734 20.8277 10.839 20.8605 10.9078 20.8734C10.9687 20.8848 11.0313 20.8848 11.0922 20.8734C11.161 20.8605 11.2266 20.8277 11.3578 20.7621L21 15.941M1 5.94098L10.6422 1.11987C10.7734 1.05428 10.839 1.02148 10.9078 1.00857C10.9687 0.997142 11.0313 0.997142 11.0922 1.00857C11.161 1.02148 11.2266 1.05428 11.3578 1.11987L21 5.94098L11.3578 10.7621C11.2266 10.8277 11.161 10.8605 11.0922 10.8734C11.0313 10.8848 10.9687 10.8848 10.9078 10.8734C10.839 10.8605 10.7734 10.8277 10.6422 10.7621L1 5.94098Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }
                                                        />
                                                        <div className={styles.cardTitleText}>
                                                            <p className={styles.cardTitlePrimaryText} id={`adminPanel_cvReviews_pipelineNameId.${index}`} data-tooltip-id={values.pipeline_name + index} onChange={addMaxViewLength(values.pipeline_name, 80)}>{concatValue}</p>
                                                            {(values.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={values.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                            <p className={styles.cardTitleSecondaryText} id={`adminPanel_cvReviews_pipelinePositionAndStageId.${index}`}>
                                                                {truncateValue(values.hiring_position, 22)}
                                                                <span className={styles.cardTitleSecondarySubText}>|</span>
                                                                {truncateValue(values.step_name, 22)}
                                                            </p>
                                                            {(values.hiring_position).length > 22 &&
                                                                <ReactTooltip id={values.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                            {(values.step_name).length > 22 &&
                                                                <ReactTooltip id={values.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr className={styles.horizontalDivider} />
                                                    <div className={styles.cardBodyText}>
                                                        <p >
                                                            {`${values.job_type === 10 ? "Full-Time" : values.job_type === 20 ? "Part-Time" : values.job_type === 30 ? "Contract/ Temp" : values.job_type === 40 ? "Casual/ Vacation" : values.job_type === 50 ? "Internship" : ''}`}
                                                            {values.work_type === 10 ? (<><span className={styles.cardBodySubText}>|</span><span>Remote</span></>) : values.work_type === 20 ? (<><span className={styles.cardBodySubText}>|</span><span>On-site</span></>) : values.work_type === 30 ? (<><span className={styles.cardBodySubText}>|</span><span>Hybrid</span></>) : null}
                                                            {values.location ? <><span className={styles.cardBodySubText}>|</span><span>{values.location}</span></>: null}
                                                        </p>
                                                    </div>
                                                    <div className={styles.reviewDetails}>
                                                        <div id="adminPanel_cvReviews_candidateCountOnCardId">
                                                            <CustomAvatarList nameArray={values.top_candidate_name_list} totalUsers={values.candidate_count}></CustomAvatarList>
                                                        </div>
                                                        <div className={styles.cardBtn}>

                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="secondaryBtn"
                                                                id="adminPanel_cvReviews_startReviewBtnId"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => viewCVDetails(values.step_id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))

                                }

                            </Row>
                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                cvReviewValues.length === 0 &&
                                (<div>
                                    <Col>
                                        <p className={styles.infoMessage}>Currently no CVs assigned to you to review. Learn more
                                            about  <a className={styles.linkText}  href='https://hiretrace.io/documentation/cv-reviews/overview' target="_blank">CV Reviews</a>. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/cvReview.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>
                </div>)
            }
        </div>
    )
}
export default CVReview;